import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { AppColors } from "../AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { Picker } from "@react-native-picker/picker";

const PaginationComponent = ({
  currentPage,
  totalPagesCount,
  onPageChange,
  pageLimit,
  onLimitChange,
}) => {
  const maxPageNumbersToShow = 6;

  const getPageNumbers = () => {
    if (totalPagesCount <= maxPageNumbersToShow) {
      return [...Array(totalPagesCount).keys()].map((i) => i + 1);
    }

    const pages = [];
    if (currentPage <= maxPageNumbersToShow - 3) {
      pages.push(1, 2, 3, 4, "...", totalPagesCount);
    } else if (currentPage >= totalPagesCount - (maxPageNumbersToShow - 3)) {
      pages.push(
        1,
        "...",
        totalPagesCount - 3,
        totalPagesCount - 2,
        totalPagesCount - 1,
        totalPagesCount
      );
    } else {
      pages.push(
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        totalPagesCount
      );
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <View style={styles.container}>
      <View style={styles.pageNumbersContainer}>
        <Text style={styles.pageLabel}>Page:</Text>
        {pageNumbers.map((number, index) => (
          <TouchableOpacity
            key={index}
            onPress={() => typeof number === "number" && onPageChange(number)}
            style={[
              styles.pageButton,
              currentPage === number && styles.activePageButton,
            ]}
            disabled={typeof number !== "number"}
          >
            <Text
              style={[
                styles.pageButtonText,
                currentPage === number && styles.activePageButtonText,
              ]}
            >
              {number}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
      <View style={styles.limitContainer}>
        <Text style={styles.limitLabel}>Items per page:</Text>
        <Picker
          selectedValue={pageLimit}
          style={styles.picker}
          onValueChange={(itemValue) => onLimitChange(itemValue)}
        >
          <Picker.Item label="5" value={5} />
          <Picker.Item label="10" value={10} />
          <Picker.Item label="25" value={25} />
        </Picker>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    paddingRight: 10,
  },
  limitContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 20,
  },
  limitLabel: {
    color: "white",
    fontSize: 14,
    fontFamily: AppFontStyle.REGULAR_ANYBODY_12.fontFamily,
    marginRight: 10,
  },
  pageLabel: {
    color: "white",
    fontSize: 14,
    fontFamily: AppFontStyle.REGULAR_ANYBODY_12.fontFamily,
    marginRight: 3,
  },
  picker: {
    height: 30,
    width: 60,
    color: "white",
    backgroundColor: AppColors.grayColor_565656,
    borderRadius: 8,
  },
  pageNumbersContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  pageButton: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: AppColors.appViolentColor_6D08C3,
    marginHorizontal: 3,
    borderRadius: 5,
  },
  activePageButton: {
    backgroundColor: AppColors.white,
  },
  pageButtonText: {
    color: "white",
    fontSize: 14,
    fontFamily: AppFontStyle.REGULAR_ANYBODY_12.fontFamily,
  },
  activePageButtonText: {
    color: AppColors.appViolentColor_6D08C3,
  },
});

export default PaginationComponent;
